export const getRevReportSelectedFilter = (state) => state.revenueReport.selectedFilter;
